import React, { Component } from 'react'
import GridCourse from './gridcourse'
import { Link } from "react-router-dom"
import ListCourse from './listcourse'
import { Tag, Input, Tooltip, Icon, Pagination, notification } from 'antd';
import moment from "moment"
import Lastviewcard from './lastView';
import './ourcourses.scss'

const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: 'Notification',
    description: message,
  });
};
function cuttext(text, maxlength) {
  if (text.length > maxlength) {
    var newtext = text.slice(0, maxlength);
    newtext += "..."
    return newtext
  } else return text
}
class OurCourses extends Component {
  constructor(props) {
    super(props)
    this.state = {
      courses: [],
      gridView: true,
      tags: [],
      inputVisible: false,
      inputValue: '',
      currentPage: 1,
      mycurrentPage: 1,
      mycourses: [],
      lastViewCourse: {},
      showMyCourses: false,
      showLastViewed: false,
      showNormalCourses: true,
      showFilteredCourses: false,
      filteredCourses: []
    }
  }
  componentWillMount() {
    this.setState({
      courses: this.props.courses,
      mycourses: this.props.mycourses,
      lastViewCourse: this.props.lastViewCourse,
      showMyCourses: this.props.showMyCourses,
      showNormalCourses: !this.props.showMyCourses
    })
  }
  componentWillReceiveProps(nextProps) {
    const { courses, mycourses, lastViewCourse, showMyCourses, showNormalCourses } = nextProps;
    if (mycourses.length > 0) {
      this.setState({ mycourses });
    }
    if (!this.state.lastViewCourse.id) this.setState({ lastViewCourse })
  }
  switchCourseArrangment = (e) => {
    e.preventDefault()
    this.setState({
      gridView: !this.state.gridView
    })
  }

  handleClose = removedTag => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    console.log(tags);
    this.setState({ tags });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }
    // console.log(tags);
    this.setState({
      tags,
      inputVisible: false,
      inputValue: '',
    });
  };

  filterByTags = (e) => {
    e.preventDefault()
    const { tags, courses } = this.state
    if (tags.length === 0) {
      openNotificationWithIcon('warning', 'Your filter can not be empty')
    } else {
      let filteredCourses = courses.filter((course) => tags.some(tag => course.tags.includes(tag)))
      this.setState({
        filteredCourses,
        showFilteredCourses: true,
        showLastViewed: false,
        showMyCourses: false,
        showNormalCourses: false
      })
    }
  }

  onPagiChange = page => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.setState({
      currentPage: page
    });
  }

  myonPagiChange = page => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.setState({
      mycurrentPage: page
    });
  }

  saveInputRef = input => (this.input = input);
  submit = (e) => {
    e.preventDefault()
  }

  switchView = (e, switching) => {
    e.preventDefault()
    this.setState({
      showMyCourses: switching,
      showNormalCourses: !switching,
      showLastViewed: false,
      showFilteredCourses: false,
      tags: []
    })
  }

  switchToLastViewed = (e, switching) => {
    e.preventDefault()
    this.setState({
      showLastViewed: switching,
      showMyCourses: false,
      showNormalCourses: false,
      showFilteredCourses: false,
      tags: []
    })
  }

  render() {
    const { courses, gridView, tags, inputVisible, inputValue, mycurrentPage, currentPage, mycourses, lastViewCourse, showMyCourses, showLastViewed, showNormalCourses, filteredCourses, showFilteredCourses } = this.state
    let start = (currentPage - 1) * 5
    let end = (5 * currentPage)
    let realEnd = end > courses.length ? courses.length : end

    let mystart = (mycurrentPage - 1) * 5
    let myend = (5 * mycurrentPage)
    let myrealEnd = myend > mycourses.length ? mycourses.length : end
    return (
      <div className={`our-course ${gridView ? 'course-grid' : 'course-list'}`}>
        <div className="container">
          <div className="row main-row">
            <div className="col-lg-9 col-md-8 col-xs-12 popular-course float-right">
              <div className="course-style-filter clearfix">
                <ul className="float-left clearfix">
                  {/* <li><a href="#" className="tran3s">Trending</a></li> */}
                  {/* <li><a href="#" className="tran3s">New</a></li> */}
                  <li><a href="#" className={`tran3s ${showNormalCourses ? 'active' : null}`} onClick={(e) => this.switchView(e, false)}>All Courses</a></li>
                  {
                    this.props.firebase.auth.uid ? <li><a href="#" className={`tran3s ${showMyCourses ? 'active' : null}`} onClick={(e) => this.switchView(e, true)}>My Playlist</a></li> : null
                  }
                  {
                    this.props.firebase.auth.uid ? <li><a href="#" className={`tran3s ${showLastViewed ? 'active' : null}`} onClick={(e) => this.switchToLastViewed(e, true)}>Currently Watching </a></li> : null
                  }
                </ul>
                {/* <ul className="float-right">
                  <li><a href="#" className={`tran3s ${gridView ? 'active' : ''}`} onClick={(e) => this.switchCourseArrangment(e)}><i className="fa fa-th-large" aria-hidden="true"></i></a></li>
                  <li><a href="#" className={`tran3s ${gridView ? '' : 'active'}`} onClick={(e) => this.switchCourseArrangment(e)}><i className="fa fa-list" aria-hidden="true"></i></a></li>
                </ul> */}
              </div>
              {
                showFilteredCourses ?
                  filteredCourses.length === 0 ?
                    <h4 style={{ marginTop: '3rem'}}>Search Result: no course matches your query</h4>
                    :
                    <React.Fragment>
                      <h4 style={{ marginTop: '3rem', marginBottom: '-2.5rem'  }}>Search Result: </h4>
                      <div className="row">
                        {
                          filteredCourses.length && filteredCourses.map((filcourse, key) => (
                            <GridCourse course={filcourse} key={key} />
                          ))
                        }
                      </div>
                    </React.Fragment>
                  : null
              }
              {
                showLastViewed ?
                  lastViewCourse.id ? <div className="row">
                    <Lastviewcard
                      lastViewCourse={lastViewCourse}
                    />
                  </div> : <div>
                      <h4 style={{ marginTop: '3rem' }}>You are yet to start taking courses</h4>
                    </div> : null
              }
              {
                showMyCourses ?
                  mycourses.length === 0 ?
                    <h4 style={{ marginTop: '3rem' }}>You are yet to start taking courses</h4>
                    :
                    <div className="row">
                      {
                        mycourses.length && mycourses.slice(mystart, myrealEnd).map((mcourse, key) => (
                          <GridCourse course={mcourse} key={key} />
                        ))
                      }
                    </div> : null
              }
              {
                showNormalCourses ? <div className="row">
                  {
                    courses.length && courses.slice(start, realEnd).map((course, key) => (
                      <GridCourse course={course} key={key} />
                    ))
                  }
                </div> : null
              }
              {
                showMyCourses && mycourses.length > 0 ?
                  <Pagination defaultCurrent={mycurrentPage} total={mycourses.length} onChange={this.myonPagiChange} className="pagi" defaultPageSize={5} /> : null
              }
              {
                showNormalCourses ? <Pagination defaultCurrent={currentPage} total={courses.length} onChange={this.onPagiChange} className="pagi" defaultPageSize={5} /> : null
              }
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div className="course-sidebar">
                <div className="course-filter">
                  <h4>Search By Filters</h4>
                  <form onSubmit={this.submit} className="main-wrapper">
                    <div className="tag-option">
                      <h5>Tags</h5>

                      <div className="main-tag-holder">
                        {tags.map((tag, index) => {
                          const isLongTag = tag.length > 20;
                          const tagElem = (
                            <Tag key={tag} closable={true} onClose={() => this.handleClose(tag)}>
                              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                            </Tag>
                          );
                          return isLongTag ? (
                            <Tooltip title={tag} key={tag}>
                              {tagElem}
                            </Tooltip>
                          ) : (
                              tagElem
                            );
                        })}
                        {inputVisible && (
                          <Input
                            ref={this.saveInputRef}
                            type="text"
                            size="small"
                            style={{ width: 78 }}
                            value={inputValue}
                            onChange={this.handleInputChange}
                            onBlur={this.handleInputConfirm}
                            onPressEnter={this.handleInputConfirm}
                          />
                        )}
                        {!inputVisible && (
                          <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
                            <Icon type="plus" /> New Tag
                          </Tag>
                        )}
                      </div>
                    </div>

                    <div className="button-wrapper"><input type="submit" value="Apply filters" className="p-bg-color tran3s" onClick={(e) => this.filterByTags(e)} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default OurCourses